import {Fragment, useRef, useState} from 'react';
import {useParams} from 'react-router-dom';
import {
  selectPermissions,
  useHMSActions,
  useHMSStore,
} from '@100mslive/react-sdk';
import {HangUpIcon} from '@100mslive/react-icons';
import {
  Button,
  Popover,
  Dialog,
  Tooltip,
  Box,
  styled,
  IconButton,
} from '@100mslive/roomkit-react';
import {
  DialogCheckbox,
  DialogContent,
  DialogRow,
} from './primitives/DialogContent';

export const LeaveRoom = (props:any) => {
  const params = useParams();
  const [showEndRoomModal, setShowEndRoomModal] = useState(false);
  const [lockRoom, setLockRoom] = useState(false);
  const permissions = useHMSStore(selectPermissions);
  const hmsActions = useHMSActions();

  const redirectToLeavePage = () => {
    if (params.role) {
      console.log('redirectToLeavePage func handling pending');
      // window.open(window.location.origin, '_self');
      // window.location.reload();
      // navigate('/leave/' + params.roomId + '/' + params.role);
    } else {
      console.log('redirectToLeavePage func handling pending');
      // window.open(window.location.origin, '_self');
      // window.location.reload();
      // navigate('/leave/' + params.roomId);
    }
  };

  const leaveRoom = () => {
    hmsActions.leave();
    window.close();
    // redirectToLeavePage();
  };

  const endRoom = () => {
    hmsActions.endRoom(lockRoom, 'End Room');
    window.close();
    // redirectToLeavePage();
  };

  return (
    <Fragment>
      {permissions?.endRoom ? (
        <Popover.Root>
          <Popover.Trigger asChild>
            <LeaveIconButton key="LeaveRoom" data-testid="leave_room_btn">
              <Tooltip title="Leave Room">
                <Box style={{display:'flex',alignItems:'center',padding:4}}>
                  <img
                    key={'hangUp'}
                    src={require('../asset/icons/Hangup.png')}
                    alt='logo'
                    width='20px'
                  />
                  <span style={{marginLeft:8, color: 'white'}}>
                    End
                  </span>
                </Box>
              </Tooltip>
            </LeaveIconButton>
          </Popover.Trigger>
          <Popover.Content sideOffset={10}>
            <Button
              variant="standard"
              css={{w: '100%'}}
              onClick={() => {
                setShowEndRoomModal(true);
              }}
              data-testid="end_room_btn">
              End Room
            </Button>
            <Button
              variant="danger"
              css={{mt: '$4'}}
              onClick={leaveRoom}
              data-testid="just_leave_btn">
              Just Leave
            </Button>
          </Popover.Content>
        </Popover.Root>
      ) : (
        <LeaveIconButton onClick={leaveRoom} variant="danger" key="LeaveRoom">
          <Tooltip title="Leave Room">
            <Box>
              <HangUpIcon key="hangUp" />
            </Box>
          </Tooltip>
        </LeaveIconButton>
      )}

      <Dialog.Root
        open={showEndRoomModal}
        onOpenChange={(value) => {
          if (!value) {
            setLockRoom(false);
          }
          setShowEndRoomModal(value);
        }}>
        <DialogContent title="End Room" Icon={HangUpIcon}>
          <DialogCheckbox
            id="lockRoom"
            title="Disable future joins"
            value={lockRoom}
            onChange={setLockRoom}
          />
          <DialogRow justify="end">
            <Button
              variant="danger"
              onClick={endRoom}
              data-testid="lock_end_room">
              End Room
            </Button>
          </DialogRow>
        </DialogContent>
      </Dialog.Root>
    </Fragment>
  );
};

const LeaveIconButton: any = styled(IconButton, {
  color: '$white',
  width: '$20',
  marginLeft: '$4',
  bg: '$error',
  '&:not([disabled]):hover': {
    bg: '$alert_error_default',
  },
  '&:not([disabled]):active': {
    bg: '$errorTint',
  },
  length: 2,
  borderRadius:'180px',
  backgroundColor:'$alert_error_default'
});
